module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.prefixCls]
  }, [_c('div', {
    class: _vm.classes,
    on: {
      "click": _vm.handleClick,
      "drop": function($event) {
        $event.preventDefault();
        _vm.onDrop($event)
      },
      "dragover": function($event) {
        $event.preventDefault();
        _vm.dragOver = true
      },
      "dragleave": function($event) {
        $event.preventDefault();
        _vm.dragOver = false
      }
    }
  }, [_c('input', {
    ref: "input",
    class: [_vm.prefixCls + '-input'],
    attrs: {
      "type": "file",
      "multiple": _vm.multiple,
      "accept": _vm.accept
    },
    on: {
      "change": _vm.handleChange
    }
  }), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _vm._t("tip"), _vm._v(" "), (_vm.showUploadList) ? _c('upload-list', {
    attrs: {
      "files": _vm.fileList
    },
    on: {
      "on-file-remove": _vm.handleRemove,
      "on-file-preview": _vm.handlePreview
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12ef4ecb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/upload/upload.vue
// module id = 595
// module chunks = 1